<div style="margin: 30px 0">
  <div class="light-blue-text otsikko">Muut selvitykset</div>

  @for (selvitys of rahanpesunSelvityksetObservable | async; track selvitys) {
    <div class="info-box" style="margin-bottom: 10px; max-width: 450px">
      <mat-form-field>
        <textarea [value]="selvitys.teksti" [disabled]="true" autocomplete="nothing" matInput data-lpignore="true"></textarea>
      </mat-form-field>
      @for (tiedosto of selvitys.tiedostot; track tiedosto) {
        <div style="cursor: pointer; color: rgba(0, 0, 0, 0.38)" (click)="downloadFile(tiedosto, selvitys.avain)">
          {{ tiedosto.nimi }}
        </div>
      }
    </div>
    <div style="margin-bottom: 50px; font-size: 11px">{{ selvitys.paivittajanNimi }} ({{ selvitys.paivitettyString }})</div>
  }

  <form>
    @if (lisaaSelvitysAktivoitu) {
      <div>
        <mat-form-field style="max-width: 450px">
          <mat-label>Selvitys</mat-label>
          <textarea type="text" [formField]="lomake.teksti" autocomplete="nothing" matInput data-lpignore="true"></textarea>
        </mat-form-field>
        @for (cached of cachedSelvitysTiedostotMetadata; track cached) {
          <div style="display: flex; align-items: center">
            <div style="margin: 10px; cursor: pointer" (click)="downloadFile(cached)">{{ cached.nimi }}</div>
            <mat-icon (click)="removeFileFromCache(cached)" style="cursor: pointer">close</mat-icon>
          </div>
        }
        <app-primary-button (click)="uploadFile()" actionId="Valitse tiedosto: Muut selvitykset (tuntemistiedot)" styles="display: block; margin-bottom: 50px;"> Lataa tiedosto </app-primary-button>
      </div>
    }
  </form>

  <div class="button-container">
    <app-button (click)="aktivoiLisaaSelvitys()" [dynamicClass]="{ secondarybutton: lisaaSelvitysAktivoitu, primarybutton: !lisaaSelvitysAktivoitu }" actionId="Avattu muokkausnäkymä: Lisää uusi muu selvitys rivi/Peruuta">
      {{ lisaaSelvitysAktivoitu ? 'Peruuta' : 'Lisää selvitys' }}
    </app-button>
    @if (lisaaSelvitysAktivoitu) {
      <app-primary-button (click)="tallenna()" actionId="Tallenna muu selvitys" [actionContext]="$any(lomake().value())" styles="margin-bottom: 10px;"> Tallenna </app-primary-button>
    }
  </div>

  @if (commonError) {
    <div class="lemon-error">{{ commonError }}</div>
  }

  <input style="visibility: hidden; height: 1px" (change)="fileChanged($event)" type="file" accept="image/*,application/pdf" #fileInput multiple="multiple" />
</div>
